<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">监控设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="DeviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in RegionData"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option key="" label="在线" value="true"></el-option>
              <el-option key="" label="离线" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="DeviceType" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in DeviceTypesArr"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="onSync" :disabled="syncing">同 步 CMS</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
            v-loading="syncing"
            :element-loading-text="syncingText"
          >
            <el-table
              v-loading="searching"
              element-loading-text="搜索中"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column
                prop="DeviceType"
                label="设备类型"
                :formatter="getDevicetypeShow"
              >
              </el-table-column>
              <el-table-column prop="Longitude" label="经度" width="140">
              </el-table-column>
              <el-table-column prop="Latitude" label="纬度" width="140">
              </el-table-column>
              <el-table-column prop="IsOnline" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.IsOnline == true">在线</span>
                </template>
              </el-table-column>
              <!-- fixed="right"  -->
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../apis";
import waitAll from "../../../../../utils/src/waitAll";

import ZJApp from "../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;

export default {
  name: "ZjMonitorHome",
  controller: "UI",
  action: "Home",
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionData: [],
      EquipmentType: "Monitor", //设备类型
      DeviceId: null,
      DeviceName: null, //设备名称
      RegionId: null, //地区ID
      area: "",
      IsOnline: null, //在线是否
      DeviceType: null,
      DeviceTypesArr: [], //设备类型的数组值

      localRegions: [], //本地区域id列表数据
      defaultRegion: null, //本地默认区域记录
      localCameraIds: [], //本地摄像头id列表数据
      localCameras: [], //本地摄像头列表数据
      regions: [], //远程区域数据
      cameras: [], //远程摄像头数据
      syncing: false,
      syncingText: "",
      pageNo: 1, //同步CMS分页使用
      syncCount: 0,
      removedCount:0,
      toRemovedList:[] // 待移除设备列表
    };
  },
  created() {
    this.getType();
    this.basedataRegion();
    this.mc = new MediaCenter();
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
  },
  mounted() {
    this.theme.sidemenu.visiable = false;
    this.search();
    // this.logInfo.ActionName = "监控设备查询";
    // this.logInfo.LogMessage = "监控设备查询";
    // this.logInfo.ModuleName = "视频监控";
    // this.logInfo.PageName = "监控设备管理列表";
    // this.addOperationLog();
  },
  methods: {
    onConnected() {
      console.debug("成功连接到媒体中心");
    },
    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log(e);
      const msg = e.data;
      if (msg.isResponse()) {
        switch (msg.msgCode) {
          case MSG.GET_PAGED_REGION_LIST:
            this.onGetRegions(msg.getJsonData());
            break;
          case MSG.GET_PAGED_CAMERA_LIST:
            this.onGetCameras(msg.getJsonData());
            break;
        }
      }
    },
    getDevicetypeShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.DeviceTypesArr;
        let result = "";
        arr.forEach((item) => {
          if (item.ItemKey == data) {
            result = item.Description;
          }
        });
        return result;
      }
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      this.searching = true;
      let online = null;
      if (this.IsOnline == "true") {
        online = true;
      } else if (this.IsOnline == "false") {
        online = false;
      }
      let lookRegionId = this.RegionId;
      if (this.RegionId == "null") {
        lookRegionId = null;
      }
      let dType = this.DeviceType;
      if (this.DeviceType == "null") {
        dType = null;
      }
      let searchInfo = {
        EquipmentType: "Monitor", //设备类型
        DeviceId: this.DeviceId,
        DeviceName: this.DeviceName, //设备名称
        DeviceType: dType,
        DeviceTypes: [],
        RegionId: lookRegionId, //地区ID
        IsOnline: online, //在线是否
        ScenicId: null, //景区ID
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      new MyApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.EquipmentType = null; //设备类型
      this.DeviceId = null;
      this.DeviceName = null; //设备名称
      this.DeviceType = null;

      this.RegionId = null; //地区ID
      this.IsOnline = null; //在线是否
    },
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(searchInfo)
        .then((r) => {
          console.log("区域");
          console.log(r);
          this.RegionData = r.data.Data;
          this.localRegions = r.data.Data.map((x) => {
            return x.RegionId;
          });
          this.defaultRegion = r.data.Data.find((x) => {
            if (x.RegionName == "其他" || x.RegionName == "其它") {
              return x;
            }
          });
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    onSync() {
      this.$confirm("确定要同步 CMS 吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.syncCount = 0;
          this.syncing = true;
          this.beginGetLocalEquipments();
        })
        .catch(() => {
          this.syncing = false;
          this.$message({
            type: "info",
            message: "已取消同步",
          });
        });
    },
    beginGetLocalEquipments() {
      this.syncingText = "查询数据库...";
      let searchInfo = {
        EquipmentType: this.EquipmentType, //设备
      };
      new MyApis.MonitorApi()
        .GetEquipmentMangeList(searchInfo)
        .then((r) => {
          if (r && r.RspCode && r.RspCode == "1") {
            r = r.data.Data;
            this.localCameraIds = r.map((x) => {
              return (x.DeviceId || "").toLowerCase();
            });
            this.localCameras = r;
            this.onGetLocalEquipments();
          } else {
            this.syncing = false;
            this.errmsg(r.RspMsg ? r.RspMsg : "未查询到本地监控数据！");
          }
        })
        .catch((e) => {
          console.log(e);
          this.syncing = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onGetLocalEquipments() {
      try {
        this.syncingText = "连接监控平台...";
        if (this.mc.$connected) {
          this.beginGetRegions();
        } else {
          this.mc.connect().then(() => this.beginGetRegions());
        }
      } catch (e) {
        console.log(e);
        this.syncing = false;
      }
    },
    beginGetRegions() {
      this.syncingText = "获取区域数据...";
      // 发送命令：分页获取区域信息
      this.pageNo = 1;
      this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
        pageNo: this.pageNo,
        pageRows: this.pageSize,
      });
    },
    // 处理获取区域的响应
    onGetRegions(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.regions.push(list[i]);
        }

        if (this.regions.length >= data.total) {
          this.syncingText = "同步区域数据...100%";
          this.onGetRegionCompleted();
        } else {
          if (data.total > 0) {
            this.syncingText =
              "同步区域数据..." +
              parseInt((this.regions.length * 100) / data.total) +
              "%";
          }
          // 获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
            pageNo: this.pageNo,
            pageRows: this.pageSize,
          });
        }
      } else {
        this.syncing = false;
        console.error(r && r.msg ? r.msg : "未获取到区域信息");
        this.$message.error("出错了: 无区域信息");
      }
    },
    // 已经获取到所有区域
    onGetRegionCompleted() {
      console.log("onGetRegionCompleted", this.regions);
      // 获取监控点信息
      this.syncingText = "同步设备信息...";
      this.pageNo = 1;
      this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
        pageNo: this.pageNo,
        pageRows: this.pageSize,
      });
    },
    // 获取到摄像机
    onGetCameras(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.cameras.push(list[i]);
        }

        if (this.cameras.length >= data.total) {
          this.syncingText = "同步监控点...100%";
          this.onGetCameraCompleted();
        } else {
          if (data.total > 0) {
            this.syncingText =
              "同步监控点..." +
              parseInt((this.cameras.length * 100) / data.total) +
              "%";
          }
          //获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
            pageNo: this.pageNo,
            pageRows: this.pageSize,
          });
        }
      } else {
        this.syncing =false;
        console.error(r && r.msg ? r.msg : "未获取到监控点信息");
        this.$message.error("出错了: 无监控点信息");
      }
    },
    // 已经获取到所有摄像机
    onGetCameraCompleted() {
      console.log("onGetCameraCompleted", this.cameras);
      let that = this;
      (this.cameras || []).forEach(function (device) {
        if (device.cameraIndexCode) {
          //判断设备是否存在于我们自己的数据库中
          if (
            that.localCameraIds.includes(device.cameraIndexCode.toLowerCase())
          ) {
            let tempDevice = (that.localCameras || []).find((x) => {
              if (
                x.DeviceId.toLowerCase() == device.cameraIndexCode.toLowerCase()
              ) {
                return x;
              }
            });
            if(tempDevice)
            {
              that.updateLocalEqument(tempDevice, device);
            }
          } else {
            that.addLocalEqument(device);
          }
        }
      });

      //this.loading = false;
      //this.buildTree();
    },
    addLocalEqument(device) {
      let that = this;
      let tempDevice = {};
      tempDevice.Extend = tempDevice.Extend || {};
      tempDevice.EquipmentType = "Monitor";
      tempDevice.DeviceId = device.cameraIndexCode;
      tempDevice.DeviceName = device.cameraName || "";
      tempDevice.DeviceType = "SubSystem.Monitor.EquipmentType.Monitor";
      tempDevice.Longitude = device.Longitude || 0;
      tempDevice.Latitude = device.Latitude || 0;
      //设置默认区域
      if (!tempDevice.RegionId && this.defRegion != null) {
        tempDevice.RegionId = this.defRegion.RegionId;
        tempDevice.RegionName = this.defRegion.RegionName;
      }
      tempDevice.Extend.Ip = device.Ip || "";
      tempDevice.Extend.Port = device.Port || 0;
      tempDevice.Extend.UserName = device.UserName || "";
      tempDevice.Extend.Password = device.Password || "";
      tempDevice.Extend.IndexCode = device.IndexCode;
      tempDevice.Extend.Channel = device.ChannelIndex || 0;
      tempDevice.Extend.EncodeDeviceID = device.encodeDevIndexCode;
      if (device.status) tempDevice.IsOnline = device.status != 0;
      tempDevice.Creater = ZJApp.ZJUser.current.UserName;
      tempDevice.CreateTime = new Date();
      tempDevice.Modifier = ZJApp.ZJUser.current.UserName;
      tempDevice.ModifyTime = new Date();
      tempDevice.Validity = 1;
      new MyApis.MonitorApi().AddEquipment(tempDevice).then(() => {
        that.syncCount = that.syncCount + 1;
        that.checkUpdateStatus();
      });
    },
    updateLocalEqument(tempDevice, device) {
      let that = this;
      //强制更新设备名称，使得本系统中的设备名称与海康平台中保持一致
      tempDevice.DeviceName = device.cameraName;
      tempDevice.Extend = tempDevice.Extend || {};

      if (device.Longitude) tempDevice.Longitude = device.Longitude;
      if (device.Latitude) tempDevice.Latitude = device.Latitude;

      //设置默认区域
      if (!tempDevice.RegionId && this.defRegion != null) {
        tempDevice.RegionId = this.defRegion.RegionId;
        tempDevice.RegionName = this.defRegion.RegionName;
      }

      if (device.Ip) tempDevice.Extend.Ip = device.Ip;

      if (device.Port) tempDevice.Extend.Port = device.Port.Value;

      if (device.UserName) tempDevice.Extend.UserName = device.UserName;

      if (device.Password) tempDevice.Extend.Password = device.Password;

      if (device.ChannelIndex && device.ChannelIndex > 0)
        tempDevice.Extend.Channel = device.ChannelIndex;

      if (device.IndexCode) tempDevice.Extend.IndexCode = device.IndexCode;

      tempDevice.Extend.EncodeDeviceID = device.encodeDevIndexCode;
      if (device.status) tempDevice.IsOnline = device.status != 0;

      tempDevice.EquipmentType = "Monitor";
      tempDevice.Modifier = ZJApp.ZJUser.current.UserName;
      tempDevice.ModifyTime = new Date();
      tempDevice.Validity = 1;

      new MyApis.MonitorApi().UpdateEquipment(tempDevice).then(() => {
        that.syncCount = that.syncCount + 1;
        that.checkUpdateStatus();
      });
    },
    checkUpdateStatus() {
      let that = this;
      let totalCount = (this.cameras || []).length;

      this.syncingText =
        "保存监控点数据..." +
        parseInt((this.syncCount * 100) / totalCount) +
        "%";
      if (this.syncCount >= totalCount) {
        that.removeNotExistDevice();
      }
    },
    removeNotExistDevice() {
      let that = this;

      this.syncingText = "移除设备...";
      this.removedCount = 0;
      this.toRemovedList = [];
      this.localCameras.forEach(function (item) {
        //判断本地数据是否存在于远程平台中，不存在则删除
        let remoteDevice = (that.cameras || []).find((x) => {
          if (x.cameraIndexCode.toLowerCase() == item.DeviceId.toLowerCase()) {
            return x;
          }
        });    
        if (!remoteDevice) {
          that.toRemovedList.push(item);
        }
      });


      if(this.toRemovedList.length == 0)
      {
        that.onRemoveNotExistDeviceCompleted();
        return;
      }

      console.log('toRemovedList',this.toRemovedList);
      this.toRemovedList.forEach(function(item){
            item.Modifier = ZJApp.ZJUser.current.UserName;
            item.ModifyTime = new Date();
            item.Validity = 0;
            new MyApis.MonitorApi().UpdateEquipment(item)
            .then((r)=>{
              console.log(r);
              that.removedCount++;
              that.syncingText =
                "移除设备..." +
                parseInt((that.removedCount * 100) / that.toRemovedList.length) +
                "%";

                if(that.removedCount >= that.toRemovedList.length){
                  that.onRemoveNotExistDeviceCompleted();
                }
            });
      });
    },
    onRemoveNotExistDeviceCompleted(){
      this.syncing = false;
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        query: {
          DeviceId: row.DeviceId,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        // name: 'mallList',
        query: {
          DeviceId: row.DeviceId,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        query: {
          type: "add",
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach((item) => {
                new MyApis.MonitorApi()
                  .DelEquipment(item)
                  .then((r) => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then((r) => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.logInfo.ActionName = "监控设备删除";
                    this.logInfo.LogMessage = "监控设备删除";
                    this.logInfo.ModuleName = "视频监控";
                    this.logInfo.PageName = "监控设备管理列表";
                    this.addOperationLog();
                    this.search();
                  }
                })
                .catch((e) => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.MonitorApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "监控设备删除";
                this.logInfo.LogMessage = "监控设备删除";
                this.logInfo.ModuleName = "视频监控";
                this.logInfo.PageName = "监控设备管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getType() {
      let that = this;
      this.config
        .getUValue(":Monitor.DeviceTypes", "")
        .then((d) => {
          console.log(d);
          that.DeviceTypesArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true
  }
};
</script>
